import { PortableText } from 'next-sanity';
import { richTextComponent } from '@/sanity/sanityPortableText';
import { PageGeneralRulesSchema } from '@/sanity/pages/PageGeneralRulesTemplate';
import heroMobileBackground from '@/public/global/hero-mobile-background.png';
import heroDesktopBackground from '@/public/global/hero_desktop_background-lg-2.png';
import { motion } from 'motion/react';
import Image from 'next/image';

const ease = [0.25, 0.1, 0.25, 1] as const;

export default function HeroSection({
  data,
}: {
  data: PageGeneralRulesSchema;
}) {
  return (
    <section className="relative w-full bg-white pt-[7rem] lg:pt-[15rem] pb-[6rem] lg:pb-[13.5rem]">
      <motion.div
        initial={{ opacity: 0, filter: 'blur(8px)' }}
        animate={{ opacity: 1, filter: 'blur(0px)' }}
        transition={{ duration: 1.2, ease }}
        className="absolute w-full h-full top-[0rem] lg:hidden block z-0 pointer-events-none"
      >
        <Image
          src={heroMobileBackground}
          alt=""
          className="w-full h-full object-cover object-center"
        />
      </motion.div>
      <motion.div
        initial={{ opacity: 0, filter: 'blur(8px)' }}
        animate={{ opacity: 1, filter: 'blur(0px)' }}
        transition={{ duration: 1.2, ease }}
        className="absolute w-full h-[130rem] top-[0rem] hidden lg:block z-0 pointer-events-none"
      >
        <Image
          src={heroDesktopBackground}
          alt=""
          className="w-full h-full object-cover object-center"
        />
      </motion.div>
      <div className="mx-auto relative z-10 flex w-[min(170.5rem,calc(100%-8rem))] flex-col items-center gap-[1.5rem]">
        {data.heroChip && (
          <p className="mb-0 font-blacker italic text-[2rem] leading-[1.5] text-black text-center">
            {data.heroChip}
          </p>
        )}

        {data.heroContent && (
          <div className="richtext richtext-center prose-headings:mb-0 prose-p:mb-0 text-center flex flex-col gap-[2rem] max-w-[95rem]">
            <PortableText
              value={data.heroContent}
              components={richTextComponent}
            />
          </div>
        )}
      </div>
    </section>
  );
}
